import { Alert, Snackbar } from '@mui/material';
import { useNotificationStore } from '@/stores/useNotificationStore';

export function NotificationSnackbar() {
  const { open, message, severity, closeNotification } = useNotificationStore();

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={closeNotification}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert severity={severity} onClose={closeNotification} role="alert">
        {message}
      </Alert>
    </Snackbar>
  );
}
